import { render, staticRenderFns } from "./dialog-two-factor-authen.vue?vue&type=template&id=54dca34e&"
import script from "./dialog-two-factor-authen.vue?vue&type=script&lang=js&"
export * from "./dialog-two-factor-authen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports